import { get } from 'lodash';
import {
  FETCH_ALL_LEADS,
  FETCH_ALL_LEADS_SUCCESS,
  FETCH_ALL_LEADS_ERROR,
  FETCH_LEAD_BY_ID,
  FETCH_LEAD_BY_ID_SUCCESS,
  FETCH_LEAD_BY_ID_ERROR,
  FETCH_ALL_POC_USER,
  FETCH_ALL_POC_USER_SUCCESS,
  FETCH_ALL_POC_USER_ERROR,
  SAVE_LEAD_FILTERS,
} from './actionTypes';
import {
  FETCH_ALL_CENTRE_WAITLIST,
  FETCH_DETAIL_ENQUIRY,
  FIND_ALL_POC_USER,
} from '../models/enquiriesManagementModels';
import { SkApolloRequest } from '../../utils/apolloUtils';
import { actionHandlerWithFeatureFlag } from '../../utils';
import { FEATURE_FLAGS } from '../../utils/constants';
import DatadogHandler from '../../utils/datadog';
import {
  msFetchEnquiryDetailAction,
  msFetchCentreWaitlistAction,
} from '../../services/CentreWaitlistService';
import { msFetchAllPOCUser } from '../../services/UserService';

const fileName = 'redux/actions/EnquiriesManagement.js';

export const saveLeadFilters = filter => async dispatch => {
  dispatch({ type: SAVE_LEAD_FILTERS, value: { filter } });
};

export const monoFetchCentreWaitlistAction = async (dispatch, reqData) => {
  dispatch({ type: FETCH_ALL_LEADS });
  try {
    const data = await SkApolloRequest({
      params: {
        query: FETCH_ALL_CENTRE_WAITLIST,
        variables: { ...reqData },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const fetchCentreWaitlistAction = reqData => async dispatch => {
  dispatch({ type: FETCH_ALL_LEADS });
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchCentreWaitlistAction,
        monoHandler: monoFetchCentreWaitlistAction,
        extraData: reqData,
      }
    );
    const success = get(data, 'success', false);
    const { findAllLeads } = get(data, 'data', {});
    if (success) {
      dispatch({
        type: FETCH_ALL_LEADS_SUCCESS,
        value: { findAllLeads },
      });
    } else {
      dispatch({
        type: FETCH_ALL_LEADS_ERROR,
        value: get(data, 'error'),
      });
    }
    return data;
  } catch (ex) {
    dispatch({
      type: FETCH_ALL_LEADS_ERROR,
      value: { error: get(ex, 'message') },
    });
    return ex;
  }
};

export const monoFetchEnquiryDetailAction = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FETCH_DETAIL_ENQUIRY,
        variables: { ...reqData },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoFetchEnquiryDetailAction',
      },
      'error'
    );
    dispatch({
      type: FETCH_LEAD_BY_ID_ERROR,
      value: { error: get(ex, 'message') },
    });
    return ex;
  }
};

export const fetchEnquiryDetailAction = reqData => async dispatch => {
  dispatch({ type: FETCH_LEAD_BY_ID });
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchEnquiryDetailAction,
        monoHandler: monoFetchEnquiryDetailAction,
        extraData: reqData,
      }
    );
    const success = get(data, 'success', false);
    const { leadByID } = get(data, 'data', {});
    if (success) {
      dispatch({
        type: FETCH_LEAD_BY_ID_SUCCESS,
        value: { leadByID },
      });
    } else {
      dispatch({
        type: FETCH_LEAD_BY_ID_ERROR,
        value: get(data, 'error'),
      });
    }
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoFetchAllPOCUser = async (dispatch, reqData) => {
  try {
    const res = await SkApolloRequest({
      params: {
        query: FIND_ALL_POC_USER,
        variables: { ...reqData },
      },
      type: 'query',
    });
    return res;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchAllPOCUser',
        fileName,
      },
      'error'
    );
    dispatch({
      type: FETCH_ALL_POC_USER_ERROR,
      value: { error: get(ex, 'message') },
    });
    return { error: ex.message };
  }
};

export const fetchAllPOCUser = reqData => async dispatch => {
  dispatch({ type: FETCH_ALL_POC_USER });
  try {
    const res = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchAllPOCUser,
        monoHandler: monoFetchAllPOCUser,
        extraData: reqData,
      }
    );
    if (res.success) {
      dispatch({
        type: FETCH_ALL_POC_USER_SUCCESS,
        value: {
          data: get(res, 'data.findAllPOCUser.data'),
        },
      });
    } else {
      dispatch({
        type: FETCH_ALL_POC_USER_ERROR,
        value: {
          error: get(res, 'error.0.message'),
        },
      });
    }
  } catch (ex) {
    return ex;
  }
};
